module.exports = __webpack_public_path__ + "img/humidity.f91528f8.svg";